import { useEffect, useState } from "react";
import MarkAsCompleteButton from "./MarkAsCompleteButton";
import SaveForLaterButton from "./SaveForLaterButton";

export default function PopupModal({
  onClose,
  children,
  /** Bottom sheet on narrow screens (md and up = centered dialog, unchanged). */
  sheetOnNarrowScreens = false,
}) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);

    // Disable scrolling when the modal is open
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 30);
  };

  return (
    <div
      className={`fixed inset-0 z-50 flex justify-center ${
        sheetOnNarrowScreens
          ? "items-end md:items-center"
          : "items-center"
      }`}
      style={{ visibility: isVisible ? "visible" : "hidden" }}
    >
      <div
        role="button"
        tabIndex={-1}
        className={`absolute inset-0 bg-black bg-opacity-50 transition-opacity duration-300 ${
          isVisible ? "opacity-100" : "opacity-0"
        }`}
        aria-hidden
        onClick={handleClose}
      />
      <div
        className={`relative z-10 bg-white p-4 shadow-lg transform transition-transform duration-300 max-h-[min(92vh,900px)] overflow-y-auto ${
          sheetOnNarrowScreens
            ? "w-full rounded-t-2xl md:rounded-lg md:w-7/12 md:max-w-[90vw]"
            : "w-11/12 md:w-7/12 rounded-lg"
        } ${isVisible ? "scale-100" : "scale-95"}`}
      >
        <button
          type="button"
          className="absolute -top-0.5 right-1.5 text-brown hover:text-gray-900 z-10 cursor-pointer"
          onClick={handleClose}
        >
          &times;
        </button>
        {children}
      </div>
    </div>
  );
}
